import React from 'react';
import { useTranslationHelper } from 'src/contexts/dependencyManager/utils';
import { getDefaultText } from './defaultText';
import {
  AccordionContentWrapper,
  AccordionHeaderWrapper,
  AccordionItemWrapper,
  StyledAccordion
} from './styles';

interface FaqCardProps {
  faqRef: React.RefObject<HTMLDivElement>;
}

const FaqContent: React.FC<FaqCardProps> = ({ faqRef }) => {
  const getText = useTranslationHelper();

  const accordionData = Array.from({ length: 11 }, (_, index) => {
    const defaultAccordionData = getDefaultText('accordion') as any;
    const itemKey = `item-${index + 1}`;
    const defaultItem = defaultAccordionData?.[itemKey] || {
      header: '',
      content: ''
    };

    return {
      id: getText(`faq.accordion.item-${index + 1}`, itemKey),
      header: (
        <span>
          {getText(
            `faq.accordion.item-${index + 1}.header`,
            defaultItem.header
          )}
        </span>
      ),
      content: (
        <p>
          {getText(
            `faq.accordion.item-${index + 1}.content`,
            defaultItem.content
          )}
        </p>
      ),
      expanded: false
    };
  });

  const accordionItems = accordionData.map((info, i) => ({
    header: {
      startArea: (
        <AccordionHeaderWrapper>
          {info.header.props.children}
        </AccordionHeaderWrapper>
      )
    },
    id: `${i}`,
    content: (
      <AccordionContentWrapper>
        {info.content.props.children}
      </AccordionContentWrapper>
    ),
    expanded: false
  }));

  const [faqData, setFaqData] = React.useState(accordionItems);

  const handleExpand = (_: any, id: number) => {
    setFaqData((prevData) =>
      prevData.map((item, index) =>
        index === id
          ? { ...item, expanded: true }
          : { ...item, expanded: false }
      )
    );
  };

  const handleCollapse = (_: any, id: number) => {
    setFaqData((prevData) =>
      prevData.map((item, index) =>
        index === id ? { ...item, expanded: false } : item
      )
    );
  };

  return (
    <div ref={faqRef}>
      {faqData.map((item, index) => (
        <AccordionItemWrapper key={index}>
          <StyledAccordion
            border="outlined"
            items={[item]}
            id={`accordion-item-${index}`}
            onExpand={(e: any) => handleExpand(e, index)}
            onCollapse={(e: any) => handleCollapse(e, index)}
          />
        </AccordionItemWrapper>
      ))}
    </div>
  );
};

export default FaqContent;
